
import {Component, Prop, Vue} from 'vue-property-decorator';
import Branch from '@/lib/Branch';
import {api} from '@/Api';
import {AxiosResponse} from 'axios';
import {ResponseGroup} from '@/lib/ResponseGroup';
@Component({})
export default class  aBranch extends Vue {
    @Prop() public branchSlug: string;
    public deleteResponseGroup(responseGroup: ResponseGroup) {
        this.$store.commit('loading');
        api.deleteResponseGroup(responseGroup.id).then((response: AxiosResponse) => {
            if (response.status === 200) {
                this.$store.commit('deleteResponseGroup', responseGroup);
            }
            this.$store.commit('loaded');
        });

    }
}
